// In this module we would place high order components which will contain others
// Routing, Initializers, Components which wait for an event to render something
import { Provider } from 'react-redux';
import { Router, Switch } from 'react-router-dom';
import { createBrowserHistory as createHistory } from 'history';
import { locale } from 'bv-i18n';

import { EmbeddedRoutesView, Layout, Services } from './features';
import { RouterAssigner } from './components';
import { Route } from './features/routing/components/shared';
import { wrapHistory } from './helpers/scrolling';

// Probably here we should call createStore
const { store } = window.reduxState;

const history = createHistory({ basename: `/${locale()}` });
wrapHistory(history);

const IndexSwitch = () => (
  <Switch>
    <Route path="/components">
      <EmbeddedRoutesView />
    </Route>
    <>
      <Layout />
      <Services />
    </>
  </Switch>
);

const IndexView = () => (
  <Provider store={store}>
    <Router history={history} basename={`/${locale()}`}>
      <IndexSwitch />
      <RouterAssigner />
    </Router>
  </Provider>
);

IndexView.displayName = 'IndexApp';

export default IndexView;
